var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubblesPagesGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 20.06V63C86 64.4905 85.4079 65.92 84.3539 66.9739C83.3 68.0279 81.8705 68.62 80.38 68.62H21.72L4 86.33V20.06C4 18.5695 4.59211 17.14 5.64606 16.086C6.70001 15.0321 8.12948 14.44 9.62 14.44H80.36C81.0997 14.4373 81.8327 14.5808 82.5168 14.862C83.201 15.1433 83.8229 15.5568 84.3469 16.0789C84.8709 16.6011 85.2866 17.2215 85.5703 17.9047C85.854 18.5878 86 19.3203 86 20.06Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0801 83.6999V102.25C96.0814 102.457 96.0418 102.662 95.9635 102.854C95.8852 103.045 95.7697 103.22 95.6238 103.367C95.4779 103.513 95.3044 103.63 95.1132 103.709C94.9221 103.789 94.7171 103.83 94.5101 103.83H76.4501C76.0311 103.83 75.6292 103.663 75.3329 103.367C75.0366 103.071 74.8701 102.669 74.8701 102.25V79.1399C74.8701 78.7209 75.0366 78.319 75.3329 78.0227C75.6292 77.7264 76.0311 77.5599 76.4501 77.5599H90.1801L96.0801 83.6999Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3199 34.47V53C37.3212 53.207 37.2816 53.4122 37.2033 53.6038C37.125 53.7955 37.0095 53.9697 36.8636 54.1166C36.7177 54.2634 36.5442 54.38 36.353 54.4595C36.1619 54.539 35.9569 54.58 35.7499 54.58H17.6899C17.4829 54.58 17.2779 54.539 17.0868 54.4595C16.8956 54.38 16.7221 54.2634 16.5762 54.1166C16.4303 53.9697 16.3148 53.7955 16.2365 53.6038C16.1582 53.4122 16.1186 53.207 16.1199 53V29.9C16.1199 29.4836 16.2853 29.0842 16.5797 28.7898C16.8742 28.4954 17.2735 28.33 17.6899 28.33H31.4199L37.3199 34.47Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8899 63.6699H140.38C141.87 63.6699 143.3 64.262 144.354 65.316C145.408 66.3699 146 67.7994 146 69.2899V135.56L128.29 117.85H69.5199C68.0294 117.85 66.5999 117.258 65.546 116.204C64.492 115.15 63.8999 113.72 63.8999 112.23V76.3099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.99 51.3199H63.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.99 42.45H75.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.99 33.58H75.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.07 101.01H122.25",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.07 92.14H134.59",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.07 83.27H134.59",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3299 34.3799H30.6399V27.1799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.26 42.09H32.27",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.26 47.2999H29.21",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.41 83.6099H90.22V76.4199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.04 91.33H91.97",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.04 96.54H88.67",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubblesPagesGrey);
export default __webpack_public_path__ + "static/media/speech_bubbles_pages_grey.af6ddaf4e8019b12a47d413d02f2b33b.svg";
export { ForwardRef as ReactComponent };